module.exports = __webpack_public_path__ + "img/evergrow.f563a5de.png";